import styled from 'styled-components';

import { NewStyleColor, StyleColor } from '../../../utils/styles-constants';
import { AvatarSize } from '../../../containers/ProfilePage/reducer';

interface ButtonProps {
	isRemove: boolean;
}

const Wrapper = styled('div')`
	flex: 1;
`;

const ImageWrapper = styled('div')`
	position: relative;
	z-index: 1;
	width: ${AvatarSize.BIG}px;
	height: ${AvatarSize.BIG}px;
	margin: 0 auto;
`;

const ImageFrame = styled('div')`
	border-radius: 50%;
	background-color: ${NewStyleColor.Grey100};

	svg {
		width: ${AvatarSize.BIG}px;
		height: ${AvatarSize.BIG}px;
	}
`;

const Button = styled('button')`
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	outline: 0;
	background-color: ${(props: ButtonProps) => props.isRemove ? NewStyleColor.Red300 : StyleColor.Blue600};
	cursor: pointer;

	svg {
		width: 12px;
		height: 12px;
		fill: ${StyleColor.White};
		${(props: ButtonProps) => !props.isRemove && 'transform: rotate(45deg);'};
	}
`;

export {
	Wrapper,
	ImageWrapper,
	ImageFrame,
	Button,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/EditableUserAvatar/styles.ts